import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";


// AuthInfo 정의
export interface iAuthInfoState {
 response : {
    username: string;
    email: string;
    name: string;
    position: string;
    department: string | null;
    company : string;
 }
  isLoading: boolean ;
  message : string | null;
}

const initialState: iAuthInfoState = {
  response: {
    username: "",
    email: "",
    name: "",
    position: "",
    department: null,
    company : "",
  },
  isLoading: false,
  message: ""
};

//get User 정보 API 
export const getUserInfoAPI = createAsyncThunk(
  "GET_USER_INFO",
  async (_, { rejectWithValue }) => {
    try {
      const djangoEndpoint = getDjangoEndpoint();
      const pathParam = '/auth/my-info/';
      const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`);
      return response.data;

    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// 슬라이스 코드
export const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserInfoAPI.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(getUserInfoAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response.username = action.payload.username;
        state.response.name = action.payload.name;
        state.response.email = action.payload.email;
        state.response.position = action.payload.position;
        state.response.department = action.payload.department;
        state.response.company = action.payload.company;
        state.message = "Login successful";
      })
      .addCase(getUserInfoAPI.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload as string || "Login failed";
        state.response.username = "";
      });
  },
});


export default userInfoSlice.reducer;